import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import { API_URL_SERVICE } from "@/commons/config";
import { AgenteRegulado } from "@/models/agente_regulado";

export class AgenteReguladoAPI extends BaseAPI<AgenteRegulado> {
  constructor() {
    super();
    this.apiUrl = `${API_URL_SERVICE}/api/solicitacao`;
  }

  public getAll(): AxiosObservable<AgenteRegulado[]> {
    return this.axios.post(`${this.apiUrl}/agentes-regulados`);
  }

  public findByArea(areaId: number): AxiosObservable<AgenteRegulado[]> {
    return this.axios.post(`${this.apiUrl}/agentes-regulados/findBy`, {
      areaId
    });
  }
}
